module.exports = __webpack_public_path__ + "img/danger.ce700573.svg";